import { Injectable } from '@angular/core';
import { Observable, catchError, map } from 'rxjs';
import { HttpService } from '../http.service';
import { HttpErrorHandlerService } from '../http-error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class BlockedsService {

  constructor(
    private httpService: HttpService,
    private errorHandler: HttpErrorHandlerService
  ) { }

  /**
   * Obtiene la lista de usuarios bloqueados por el usuario actual
   * @returns Observable con un array de usuarios bloqueados
   */
  getBlockedUsers(): Observable<any[]> {
    return this.httpService.get(`blocked-users`).pipe(
      map((response: any) => {
        return response.data || [];
      }),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  /**
   * Desbloquea un usuario previamente bloqueado
   * @param userId ID del usuario a desbloquear
   * @returns Observable con la respuesta del servidor
   */
  unblockUser(userId: number): Observable<any> {
    return this.httpService.delete(`blocked-users/${userId}`).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  /**
   * Bloquea a un usuario
   * @param userId ID del usuario a bloquear
   * @returns Observable con la respuesta del servidor
   */
  blockUser(userId: number): Observable<any> {
    return this.httpService.post(`blocked-users`, { blocked_id: userId }).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }
}
